import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { selectApp, selectAuth, selectMerchant } from "@redux";
import { useTranslation } from "react-i18next";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";
//@ts-ignore

export const PageTestPage2 = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();

    const { loading } = useSelector(selectApp);
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    //page state

    const fullHeight = useFullScreen();

    return (
        <StyledReceiptPage themeColor={themes?.themeColor!} style={{ height: fullHeight }}>
            <h2>TESTPAGE</h2>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi doloribus
                repellendus veniam quisquam, voluptas, dolore similique vitae obcaecati sint iusto
                facilis quidem. Voluptatum vel tempora at reiciendis quaerat iusto itaque?
            </p>
        </StyledReceiptPage>
    );
};

const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100vh;
    padding: 20px;
    position: relative;
    background-color: #ff0000;
    position: relative;
    .layout-img-skeleton {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 250px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .step-logo {
        display: flex;
        justify-content: center;
        .ant-skeleton {
            .ant-skeleton-header {
                text-align: center;
                padding-right: 0;
                span {
                    width: 105px;
                    height: 105px;
                    margin: 0 auto;
                }
            }
        }
        .step {
            display: flex;
            p {
                margin: none;
                background-color: ${(p) => p.themeColor};
                padding: 2px 10px 4px 10px;
                color: ${(p) => p.theme.colors.white};
                border-radius: 100px;
                font-size: 16px;
            }
            div {
                border-top: 3px solid ${(p) => p.themeColor};
                height: 3px;
                width: 20px;
                margin-top: 14px;
            }
        }
        .logo {
            width: 75px;
            height: 75px;
            border-radius: 100%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .info {
        text-align: right;
        margin-bottom: 5px;
        img {
            width: 18px;
        }
    }
    .seller-input-section {
        input {
            border: 1px solid ${(p) => p.themeColor};
            border-radius: 15px;
            height: 68px !important;
            color: black;
        }
        .ant-input-suffix {
            z-index: 0;
        }
        .input-btn {
            color: #ffffff;
            background-color: ${(p) => p.themeColor};
            border-radius: 12px;
            height: 43px;
        }
    }
    .ex-receipt {
        font-size: 12px;
        color: ${(p) => p.themeColor};
        text-decoration: underline;
        text-align: center;
        margin-bottom: 16px;
    }
    .title-receipt {
        margin-bottom: 16px;
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-title {
                    margin-top: 15px;
                    margin-bottom: 12px;
                    height: 10px;
                    border-radius: 16px;
                }
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 15px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
        h1 {
            font-size: 28px;
            font-weight: 500;
            color: #01040d;
            margin: 8px 0;
        }
        p {
            color: #96979c;
            font-size: 16px;
            line-height: 19px;
            font-weight: 400;
        }
    }

    .box-image {
        margin: 15px 0px 16px;
        background-color: rgba(0, 162, 147, 0.08);
        border-radius: 20px;
        text-align: center;
        // border: 1px dashed ${(p) => p.themeColor};
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        min-height: 150px;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            img {
                max-width: 100%;
                max-height: 200px;
                border-radius: 16px;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .view-btn-type-2 {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        background-color: ${(p) => p.theme.colors.card};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 40px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }
    .scan-qr {
        text-align: center;
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-top: 20px;
        section {
        }
    }

    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
    }
    .content-layout {
        width: 100%;
        height: auto;
        min-height: 80dvh;
        .content {
            padding: 20px;
            width: 100%;
            height: 80vh;
            padding-bottom: 28px;
            background: ${(p) => p.theme.colors.card};
            position: relative;
            border-radius: 16px 16px 0 0;
            bottom: 0;
            margin: auto;
            text-align: center;
            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
                transform: rotate(0deg);
                transition: 0.6s;
                &:hover {
                    transform: rotate(90deg);
                }
            }
            .text-title {
                font-weight: 600;
                font-size: 24px;
                color: ${(p) => p.themeColor};
            }
            .content-text {
                margin: 16px 0;
                p {
                    font-size: 14px;
                    line-height: 24px;
                    text-align: left;
                }
            }
            .content-info {
                border-radius: 16px;
                padding: 20px;
                .img-section {
                    background-color: ${(p) => p.themeColor}30;
                    height: 40vh;
                    border-radius: 25px;
                    margin-bottom: 30px;
                    img {
                        max-width: 100%;
                        max-height: 35vh;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
`;
